/** Indicatif téléphonique par défaut — Guyane française. */
export const DEFAULT_PHONE_DIAL_CODE = "+594";

export interface PhoneDialOption {
  dialCode: string;
  label: string;
}

/** Indicatifs proposés dans les formulaires (DOM + métropole). */
export const PHONE_DIAL_OPTIONS: PhoneDialOption[] = [
  { dialCode: "+594", label: "Guyane (+594)" },
  { dialCode: "+590", label: "Guadeloupe (+590)" },
  { dialCode: "+596", label: "Martinique (+596)" },
  { dialCode: "+262", label: "La Réunion (+262)" },
  { dialCode: "+262269", label: "Mayotte (+262)" },
  { dialCode: "+33", label: "France (+33)" },
];

export function formatPhoneDisplay(
  dialCode: string | null | undefined,
  phone: string | null | undefined,
): string {
  const local = phone?.trim();
  if (!local) return "";
  const dial = dialCode?.trim() || DEFAULT_PHONE_DIAL_CODE;
  return `${dial} ${local}`;
}

export function toTelHref(
  dialCode: string | null | undefined,
  phone: string | null | undefined,
): string {
  const local = phone?.replace(/\D/g, "") ?? "";
  if (!local) return "";
  const dial = (dialCode ?? DEFAULT_PHONE_DIAL_CODE).replace(/\D/g, "");
  return `tel:+${dial}${local}`;
}

/** Sépare un numéro stocké en un seul champ (données historiques). */
export function splitStoredPhone(
  stored: string | null | undefined,
  dialCodeFallback = DEFAULT_PHONE_DIAL_CODE,
): { dialCode: string; phone: string } {
  const raw = stored?.trim() ?? "";
  if (!raw) return { dialCode: dialCodeFallback, phone: "" };

  const byLength = [...PHONE_DIAL_OPTIONS].sort(
    (a, b) => b.dialCode.length - a.dialCode.length,
  );
  for (const option of byLength) {
    if (raw.startsWith(option.dialCode)) {
      return { dialCode: option.dialCode, phone: raw.slice(option.dialCode.length).trim() };
    }
  }
  if (raw.startsWith("00")) {
    for (const option of byLength) {
      const intl = option.dialCode.slice(1);
      if (raw.startsWith(`00${intl}`)) {
        return { dialCode: option.dialCode, phone: raw.slice(2 + intl.length).trim() };
      }
    }
  }
  return { dialCode: dialCodeFallback, phone: raw };
}
